import type { ActKc2UerCostPlotData } from 'gql/graphql';
import { Area } from 'uikit';
import { capitalize } from 'utils';
import { getMonthName } from 'utils/formatDateToLocale';

import React, { useMemo } from 'react';

import { areaStyle, tooltip, yAxis } from './AnalyticsBySeasonsChart';

import Style from './AnalyticsBySeasonsChart.module.css';

interface IAnalyticsBySeasonChart {
    items?: ActKc2UerCostPlotData[] | null;
    seasonYear: number;
}

const xAxis = {
    label: {
        formatter: (v: string) => (v !== 'start' ? v : ''),
        style: {
            fontSize: 16,
        },
    },
};

const meta = {
    date: {
        range: [0, 1],
    },
};

export const AnalyticsBySeasonChart: React.FC<IAnalyticsBySeasonChart> = (props) => {
    const { items, seasonYear } = props;

    const areaData = useMemo(() => {
        const result = [];

        for (let i = 0; i < 12; i++) {
            const itemToSet = items?.find((iAct) => {
                const itemDate = new Date(iAct.date);

                return itemDate.getMonth() === i && itemDate.getFullYear() === seasonYear;
            });

            if (!i) {
                result.push({
                    date: 'start',
                    type: 'Принято в Акте КС-2',
                    value: 0,
                });
                result.push({
                    date: 'start',
                    type: 'Согласовано СКзC',
                    value: 0,
                });
            }

            const date = capitalize(getMonthName(i + 1));

            result.push({
                date,
                type: 'Принято в Акте КС-2',
                value: itemToSet?.rimActKC2WorkCost || 0,
            });
            result.push({
                date,
                type: 'Согласовано СКзC',
                value: itemToSet?.skzsActKC2WorkCost,
            });
        }

        return result;
    }, [items, seasonYear]);

    return (
        <Area
            className={Style.analyticsBySeasonsChart}
            xField="date"
            yField="value"
            seriesField="type"
            data={areaData}
            areaStyle={areaStyle}
            yAxis={yAxis}
            xAxis={xAxis}
            legend={false}
            isStack={false}
            tooltip={tooltip}
            meta={meta}
        />
    );
};

AnalyticsBySeasonChart.displayName = 'AnalyticsBySeasonChart';

export const MemoizedAnalyticsBySeasonChart = React.memo(AnalyticsBySeasonChart);
